import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getTileImages, Tile } from '../../types/tile.types';
import { getAccessibleIconColor } from '../../utils/contrast-color.util';

const DEFAULT_ICON = 'ri-apps-2-line';
const REMIX_ICON_CLASS_PATTERN = /^ri-[a-z0-9-]+$/;

/** Icon einer Kachel in Listen und Badges: das Icon-Bild, falls gesetzt, sonst das RemixIcon.
 * Mit Bild ist das RemixIcon bewusst nicht mehr sichtbar. Das Bild füllt das umschließende,
 * abgerundete Badge (`display: contents`, `border-radius: inherit`); ohne Badge (`inline`) ist
 * es so groß wie ein Icon im Fließtext. */
@Component({
    selector: 'app-tile-icon',
    standalone: true,
    imports: [CommonModule],
    template: `
        <img
            *ngIf="imageUrl && imageUrl !== failedUrl; else symbol"
            [src]="imageUrl"
            [class.tile-icon-inline]="inline"
            alt=""
            (error)="failedUrl = imageUrl"
        >
        <ng-template #symbol><i
                [ngClass]="iconClass"
                [ngStyle]="{color: inline ? symbolColor : iconColor}"
                aria-hidden="true"
            ></i></ng-template>
    `,
    styles: [`
        :host { display: contents; border-radius: inherit; }
        img { display: block; width: 100%; height: 100%; object-fit: cover; border-radius: inherit; }
        img.tile-icon-inline { width: 1.25em; height: 1.25em; border-radius: 0.3em; flex: none; }
    `]
})
export class TileIconComponent {
    @Input({ required: true }) public tile?: Partial<Tile>;
    /** Ohne farbiges Badge drumherum, z. B. in Chips oder Tabellenzellen. */
    @Input() public inline = false;
    /** Farbe des RemixIcons im `inline`-Modus (im Badge ergibt sie sich aus dem Kontrast zur Akzentfarbe). */
    @Input() public symbolColor?: string;
    public failedUrl?: string;

    public get imageUrl(): string { return this.tile ? getTileImages(this.tile).iconImageUrl : ''; }

    public get iconClass(): string {
        const icon = this.tile?.icon;
        return icon && REMIX_ICON_CLASS_PATTERN.test(icon) ? icon : DEFAULT_ICON;
    }

    public get iconColor(): string {
        return getAccessibleIconColor(this.tile?.color ?? '#6366f1');
    }
}
